import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalOrderDetail = ({ customerNumber, workOrderNumber, titleSetter }) => {
  const { t } = useTranslation()

  const Fdata = new FormData()
  Fdata.append('order_status_detail[customer_number]', customerNumber)
  Fdata.append('order_status_detail[work_order_number]', workOrderNumber)
  const { data, loading, error } = useAxiosPartnerPortal(
    // die Parameter "customerNumber" und "workOrderNumber" werden in der
    //    apiURL eigentlich nicht benötigt
    //    => sie werden hier nur reingegeben, damit sich die URL beim Klick auf
    //       eine andere Bestellung verändert und der axiosHook ausgeführt wird
    apiURL('order_status_detail?c=' + customerNumber + '&w=' + workOrderNumber),
    Fdata,
    'post'
  )

  if (data) {
    titleSetter('Auftragspositionen zum Kundenauftrag ' + workOrderNumber)
  }

  return (
    <div data-spa-type="order_status_detail">
      <div data-spa-result-for="order_status_detail">
        {loading && <LoadingSpinner />}
        {data && (
          <table className="table table-condensed table-striped">
            <thead>
              <tr>
                {t('generic.spa.results.order_status.detail_columns').map(
                  (col, index) => (
                    <th key={index}>{col}</th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.positionsnr}</td>
                  <td>{row.material}</td>
                  <td>{row.bezeichnung}</td>
                  <td>
                    {row.menge} {row.einheit}
                  </td>
                  <td>{row.merkmale}</td>
                  <td>{row.sonder}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default ModalOrderDetail
